export const CONTROL_TOOLTIPS = {
  showRollupHierarchy: 'Group positions for each subaccount within its rollup hierarchy tree',
  showZeroBalances: 'Include historical positions that currently have zero balances',
  includeCash: `Include positions in cash instruments – fiat, and also stablecoins if ‘Treat Stablecoins as Cash’ enabled in Settings`,
  alignPricesOnDecimal:
    'Prices in the Bid and Offer columns will be aligned on the decimal point instead of using the standard bid-left and offer-right alignment.',
  enableBBO: 'Highlight the best bid and offer rates for a symbol when multiple price columns are added.',
  showLegMarketSelector: 'Show or hide the Market Selector column on each leg.',
} as const;
